module["exports"] = ["### ###", "### ###", "### ###", "### ### ####", "+385 ## ### ###", "00385 ## ### ###"];